import * as Yup from "yup";
import React from "react";
import { Box, Button, Grid } from "@mui/material";
import { postSubmit } from "../../../fetch/postSubmit";
import { getLayoutView } from "../../../components/layout/getLayoutView";
import { getLayoutText } from "../../../components/layout/getLayoutText";
import PkCommonInfo from "../../../components/common/PkCommonInfo";
import PkCommonResponse  from "../../../components/common/PkCommonResponse";

function postStyle() {
  return (theme) => ({
    ...{
      mb: 4,
      "& .MuiInputLabel-root.Mui-disabled, & .MuiInputLabel-root": {
        color: theme.palette.grey[500],
      },
      "& .MuiInputBase-root.Mui-disabled": {
        color: {
          xs: theme.palette.grey[400],
          lg: theme.palette.grey[700],
        },
      },
      "& .MuiInputBase-root": {
        "& input::placeholder, & textarea::placeholder": {
          color: theme.palette.grey[500],
        },
        border: 2,
        borderRadius: "4px",
        borderColor: theme.palette.grey[500],
        color: {
          xs: theme.palette.grey[700],
          lg: theme.palette.grey[300],
        },
      },
    },
  });
}

export function Apply() {
  const [viewer, viewerSet] = React.useState(<></>);
  const [status, statusSet] = React.useState({
    range: `visual`,
    submit: false,
  });
  return (
    <Box sx={{ p: { xs: `0 5% 0`, sm: `0 10% 0` }, backgroundColor: "white" }}>
      <Grid container columnSpacing={8}>
        <Grid item xs={12} lg={6}>
          {getLayoutView(
            <>
              HELP <span style={{ fontFamily: "Lato-Bold" }}>CHANGE</span> THE{" "}
              <span style={{ fontFamily: "Lato-Bold" }}>NARRATIVE</span>{" "}
            </>,
            [
              getLayoutText(
                <>
                  Apply now and become part of a community dedicated to bringing
                  a new age of interactive content.
                </>,
                {
                  fontSize: "1.25rem",
                  fontFamily: "Lato-Regular",
                  lineHeight: 2.25,
                },
              ),
            ],
            [12],
            {
              p: 0,
              textAlign: `center`,
              backgroundColor: `transparent`,
              "& .MuiTypography-root:not(.MuiTypography-caption)": {
                color: (theme) => theme.palette.grey[600],
              },
            },
          )}
        </Grid>
        <Grid item xs={12} lg={6} sx={{ py: 6 }}>
          <Box
            sx={(theme) => ({
              ...{
                mx: "auto",
                p: { xs: 0, lg: 4 },
                maxWidth: "500px",
                borderRadius: "8px",
                backgroundColor: {
                  xs: `transparent`,
                  lg: theme.palette.grey[800],
                },
              },
            })}
          >
            {((
              _yup = {
                url: (v) =>
                  Yup.string().url().required("Required").validateSync(v),
                tag: (v) =>
                  Yup.string().min(2).required("Required").validateSync(v),
              },
            ) => (
              <>
                <Box sx={postStyle()}>
                  <PkCommonInfo
                    disabled={status.submit}
                    validate={_yup.tag}
                    update={(v) =>
                      statusSet({ ...status, fname: v, submit: false })
                    }
                    format={(v) => v}
                    value=""
                    label="FIRST NAME"
                    name="firstName"
                    variant="standard"
                    required
                  />
                </Box>
                <Box sx={postStyle()}>
                  <PkCommonInfo
                    disabled={status.submit}
                    validate={_yup.tag}
                    update={(v) =>
                      statusSet({ ...status, lname: v, submit: false })
                    }
                    format={(v) => v}
                    value=""
                    label="LAST NAME"
                    name="lastName"
                    variant="standard"
                    required
                  />
                </Box>
                <Box sx={postStyle()}>
                  <PkCommonInfo
                    disabled={status.submit}
                    validate={(v) =>
                      Yup.string().email().required("Required").validateSync(v)
                    }
                    update={(v) =>
                      statusSet({ ...status, email: v, submit: false })
                    }
                    format={(v) => v}
                    value=""
                    label="EMAIL ADDRESS"
                    name="email"
                    variant="standard"
                    required
                  />
                </Box>
                <Box sx={postStyle()}>
                  <PkCommonInfo
                    disabled={status.submit}
                    validate={_yup.url}
                    update={(v) =>
                      statusSet({ ...status, media: v, submit: false })
                    }
                    format={(v) => v}
                    value=""
                    label="SOCIAL MEDIA"
                    name="media"
                    variant="standard"
                    placeholder="http://"
                    required
                  />
                </Box>
                <Box sx={postStyle()}>
                  <PkCommonInfo
                    disabled={status.submit}
                    validate={(v) => true}
                    update={(v) =>
                      statusSet({
                        ...status,
                        range: v === `0` ? `visual` : `audio`,
                        submit: false,
                      })
                    }
                    format={(v) => v}
                    name="type"
                    value="0"
                    label="Talent Category"
                    variant="standard"
                    select={true}
                    options={[
                      {
                        label:
                          "Visual - Think CG generalist with an eye for detail",
                        value: "0",
                      },
                      {
                        label:
                          "Audio - Think music producer with an ear for effects",
                        value: "1",
                      },
                    ]}
                  />
                </Box>
                <Button
                  disabled={status.submit}
                  fullWidth
                  variant="contained"
                  sx={{
                    mt: 1.25,
                    "&.MuiButtonBase-root.Mui-disabled": (theme) => ({
                      ...{
                        xs: {
                          color: theme.palette.grey[400],
                          backgroundColor: theme.palette.grey[300],
                        },
                        lg: {
                          color: theme.palette.grey[500],
                          backgroundColor: theme.palette.grey[700],
                        },
                      },
                    }),
                  }}
                  onClick={() => {
                    statusSet({ ...status, submit: true });
                    postSubmit(
                      {
                        type: "CONTRIBUTOR",
                        ...(({ submit, ...r }) => r)(status),
                      },
                      (status) => {
                        if (status !== 200) {
                          statusSet({ ...status, submit: false });
                          viewerSet(
                            <PkCommonResponse
                              type="error"
                              response="Please fill in all required fields. If the error persists, refresh the page or reach out to request@polycaik.com."
                            />,
                          );
                          return;
                        }
                        viewerSet(
                          <PkCommonResponse response="Thank you for your interest. We will be in touch." />,
                        );
                      },
                    );
                  }}
                >
                  APPLY NOW
                </Button>
              </>
            ))()}
          </Box>
          {viewer}
        </Grid>
      </Grid>
    </Box>
  );
}
